angular
    .module("index.controller")
    .controller('AppCtrl', ['$scope', '$rootScope', '$filter', '$window', '$location', '$timeout', 'popupService', 'commonService', 'notificationContextEnum', 'jurisdictionEnum',
        function ($scope, $rootScope, $filter, $window, $location, $timeout, popupService, commonService, notificationContextEnum, jurisdictionEnum) {
            $scope.notificationContextEnum = notificationContextEnum;
            $rootScope.loaderOn = false;
            $rootScope.pageWidth = $window.innerWidth;
            $rootScope.pageHeight = $("#page-container").innerHeight();
            $rootScope.backBtnCallMain = "";
            $rootScope.passwordResetPopupOn = false;
            $rootScope.clickOutsideClicked = true;
            $rootScope.pageNavigationHistory = {
                PolicyId: "",
                PolicyNumber: "",
                EmployerName: "",
                ClaimId: ""
            };

            function lockScreen(isLockScreen) {
                if (isLockScreen) {
                    var controller = {
                        showHeader: false,
                        showCloseButton: false
                    };
                    popupService.show('index', 'loginAttempts', controller);
                } else {
                    popupService.hide();
                }
            }

            $rootScope.closePopups = function () {
                $rootScope.changePasswordPopupOn = $rootScope.passwordResetPopupOn = false;
                popupService.hide();
                $rootScope.clickOutsideClicked = true;
            };

            $scope.$watch(function () {
                return $filter('dec2num')(sessionStorage.loginAttempts);
            }, function () {
                if ($filter('dec2num')(sessionStorage.loginAttempts) >= 3) {
                    lockScreen(true);

                    $timeout(function () {
                        sessionStorage.loginAttempts = $filter('enstr64')(0);
                        lockScreen(false);
                    }, 15000);
                }
            }, true);

            $scope.$watch(function () {
                return $filter('dec2bool')(sessionStorage.LoggedIn);
            }, function (newVal) {
                if (newVal) commonService.getLastEtlTime();
            }, true);

            $scope.$watch(function () {
                return $(".popup").is(':visible');
            }, function (newVal) {
                if (newVal !== true) {
                    return;
                }
                //var perc = window.pageYOffset / $rootScope.pageHeight * 100 + 15,
                //    fromTop = $rootScope.deviceType === false ? Number($rootScope.pageHeight * perc / 100) : window.pageYOffset + 20;

                $timeout(function () {
                    $rootScope.pageHeight = $("#page-container").innerHeight();
                    $(".popup").height($rootScope.pageHeight);
                    //$(".popup-box").css({ top: fromTop});
                }, 300);

                $rootScope.clickOutsideClicked = false;
            }, true);

            $rootScope.$on('$locationChangeSuccess', function (absUrl, newUrl, currentUrl, oldState) {
                if (newUrl !== currentUrl) {
                    popupService.hide();
                }
                $rootScope.backBtnCallMain = $rootScope.backBtnCall || "";
                $rootScope.actualLocation = $location.path();
            });

            $rootScope.$watch(function () {
                return $location.path();
            }, function (newLocation) {
                if ($rootScope.actualLocation === newLocation) {
                    $scope.$eval($rootScope.backBtnCallMain);
                } else {
                    $timeout(function () {
                        document.body.scrollTop = document.documentElement.scrollTop = 0;
                    }, 1000);
                }
            });

            $scope.init = function () {
            }
        }
    ]); //main controller on enter page